module.exports = __webpack_public_path__ + "img/360.42c0bcaa.jpg";